import React from "react";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Tab from "react-bootstrap/Tab";
import ProjectCard from "../ProjectCard/ProjectCard";
import Row from "react-bootstrap/Row";

const ShowProject = (props) => {
  const { html_css, javascript, latest, mern, native, react, node, nextjs } =
    props.project;

  const tabItem = [
    "Latest",
    "MERN",
    "Node",
    "React",
    "JavaScript",
    "HTML&CSS",
    "NextJs",
    "Native",
  ];

  return (
    <Row>
      <Col md={2} lg={2} sm={3}>
        <Nav variant="pills" className="flex-column">
          {tabItem.map((tabList) => {
            return (
              <Nav.Item>
                <Nav.Link eventKey={tabList}>{tabList}</Nav.Link>
              </Nav.Item>
            );
          })}
        </Nav>
      </Col>
      <Col md={10} lg={10} sm={9}>
        <Tab.Content>
          <Tab.Pane eventKey="Latest">
            <div className="row">
              {latest.map((latestProject) => {
                const { title, img, tech, code, live, id, backend } =
                  latestProject;
                return (
                  <div className="col-lg-4 col-md-6 mb-4" key={id}>
                    <ProjectCard
                      title={title}
                      img={img}
                      tech={tech}
                      code={code}
                      live={live}
                      backend={backend}
                    />
                  </div>
                );
              })}
            </div>
          </Tab.Pane>
          <Tab.Pane eventKey="MERN">
            <div className="row">
              {mern.map((mernProject) => {
                const { title, img, tech, code, live, id, backend } =
                  mernProject;
                return (
                  <div className="col-lg-4 col-md-6 mb-4" key={id}>
                    <ProjectCard
                      title={title}
                      img={img}
                      tech={tech}
                      code={code}
                      live={live}
                      backend={backend}
                    />
                  </div>
                );
              })}
            </div>
          </Tab.Pane>
          <Tab.Pane eventKey="Node">
            <div className="row">
              {node.map((nodeProject) => {
                const { title, img, tech, code, live, id } = nodeProject;
                return (
                  <div className="col-lg-4 col-md-6 mb-4" key={id}>
                    <ProjectCard
                      title={title}
                      img={img}
                      tech={tech}
                      code={code}
                      live={live}
                    />
                  </div>
                );
              })}
            </div>
          </Tab.Pane>
          <Tab.Pane eventKey="React">
            <div className="row">
              {react.map((reactProject) => {
                const { title, img, tech, code, live, id } = reactProject;
                return (
                  <div className="col-lg-4 col-md-6 mb-4" key={id}>
                    <ProjectCard
                      title={title}
                      img={img}
                      tech={tech}
                      code={code}
                      live={live}
                    />
                  </div>
                );
              })}
            </div>
          </Tab.Pane>
          <Tab.Pane eventKey="JavaScript">
            <div className="row">
              {javascript.map((jsProject) => {
                const { title, img, tech, code, live, id } = jsProject;
                return (
                  <div className="col-lg-4 col-md-6 mb-4" key={id}>
                    <ProjectCard
                      title={title}
                      img={img}
                      tech={tech}
                      code={code}
                      live={live}
                    />
                  </div>
                );
              })}
            </div>
          </Tab.Pane>
          <Tab.Pane eventKey="HTML&CSS">
            <div className="row">
              {html_css.map((hcProject) => {
                const { title, img, tech, code, live, id } = hcProject;
                return (
                  <div className="col-lg-4 col-md-6 mb-4" key={id}>
                    <ProjectCard
                      title={title}
                      img={img}
                      tech={tech}
                      code={code}
                      live={live}
                    />
                  </div>
                );
              })}
            </div>
          </Tab.Pane>
          <Tab.Pane eventKey="NextJs">
            <div className="row">
              {nextjs.map((nxjProject) => {
                const { title, img, tech, code, live, id } = nxjProject;
                return (
                  <div className="col-lg-4 col-md-6 mb-4" key={id}>
                    <ProjectCard
                      title={title}
                      img={img}
                      tech={tech}
                      code={code}
                      live={live}
                    />
                  </div>
                );
              })}
            </div>
          </Tab.Pane>
          <Tab.Pane eventKey="Native">
            <div className="row">
              {native.map((ntProject) => {
                const { title, img, tech, code, live, id } = ntProject;
                return (
                  <div className="col-lg-4 col-md-6 mb-4" key={id}>
                    <ProjectCard
                      title={title}
                      img={img}
                      tech={tech}
                      code={code}
                      live={live}
                      id={id}
                    />
                  </div>
                );
              })}
            </div>
          </Tab.Pane>
        </Tab.Content>
      </Col>
    </Row>
  );
};

export default ShowProject;
